import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from '@mustauto/ui/web';
import { formatDayMonthBR } from '@mustauto/utils';
import { CHART_COLORS } from '@/lib/status';
import type { ChartDataPoint } from '@/hooks/useDashboard';

const SERIES = [
  { key: 'in_analysis', name: 'Em Análise' },
  { key: 'in_execution', name: 'Em Execução' },
  { key: 'waiting_part', name: 'Aguardando Peça' },
  { key: 'outsourced', name: 'Terceirizado' },
  { key: 'completed', name: 'Concluídas' },
  { key: 'waiting_payment', name: 'Ag. Pagamento' },
  { key: 'cancelled', name: 'Canceladas' },
] as const;

export function OSChart({ data }: { data: ChartDataPoint[] }) {
  const formatted = data.map((d) => ({
    ...d,
    date: formatDayMonthBR(d.date),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base font-semibold text-foreground">
          OS por Status — Últimos 7 dias
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={formatted} barCategoryGap="20%">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis dataKey="date" tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }} stroke="var(--color-border)" />
            <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }} stroke="var(--color-border)" />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                borderColor: 'var(--color-border)',
                borderRadius: '0.5rem',
                color: 'var(--color-foreground)',
              }}
            />
            <Legend wrapperStyle={{ color: 'var(--color-foreground)' }} />
            {SERIES.map(({ key, name }) => (
              <Bar
                key={key}
                dataKey={key}
                name={name}
                fill={CHART_COLORS[key]}
                radius={[4, 4, 0, 0]}
                stackId="stack"
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
